export default __webpack_public_path__ + "9481f9db60125f9f0bd6a3c13a6b35f8.svg";